import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./mobile-config.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./mobile-config.component.scss?ngResource";
import { Component, ChangeDetectorRef } from "@angular/core";
import { mobileConfigHeadingLookup, MobileConfigConstants, } from "./mobile-config.constants";
import { of } from "rxjs";
import { AlertType } from "../../shared/models/alert";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedConstants } from "../../shared/constants/shared.constants";
import { MobileConfigSettingsService } from "./mobile-config-settings/mobile-config-settings.service";
import { CreateMobileConfigComponent } from "./create-mobile-config/create-mobile-config/create-mobile-config.component";
import { AppControllerService } from "../../app-controller.service";
import { EditMobileConfigComponent } from "./edit-mobile-config/edit-mobile-config/edit-mobile-config.component";
import { AutoUnsub } from "../../shared/decorators/autounsub.decorator";
let MobileConfigComponent = class MobileConfigComponent {
    MobileConfigService;
    appControllerService;
    changeDetectorRefs;
    modalService;
    formHeader = MobileConfigConstants.FORM_HEADER;
    saveButtonLabel = MobileConfigConstants.SAVE_BTN_TEXT_PLACEHOLDER;
    editButtonLabel = MobileConfigConstants.EDIT_BUTTON_LABEL;
    selectedOrganisation;
    tableDataSource;
    existingMobileConfigs;
    tableMapper;
    tableSelection = [];
    addModalTitle = MobileConfigConstants.CREATE_MOBILE_CONFIG_TITLE;
    selectMobMessage = SharedConstants.NO_ITEM_SELECTED;
    moreThanOneMobSelectedMessage = SharedConstants.MORE_THAN_ONE_SELECTED;
    editModalTitle = MobileConfigConstants.EDIT_MOBILE_CONFIG_TITLE;
    getMobileConfigsSubscription;
    constructor(MobileConfigService, appControllerService, changeDetectorRefs, modalService) {
        this.MobileConfigService = MobileConfigService;
        this.appControllerService = appControllerService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.modalService = modalService;
        this.initializeColumnToObjectMapping();
    }
    ngOnInit() {
        this.getMobileConfigs();
    }
    getMobileConfigs() {
        this.getMobileConfigsSubscription =
            this.MobileConfigService.getMobileConfigs()
                .subscribe((mobileConfigs) => {
                // @ts-ignore
                this.tableDataSource = of(mobileConfigs.value);
                this.changeDetectorRefs.detectChanges();
            });
    }
    arrayReturned(array) {
        this.tableSelection = array;
    }
    initializeColumnToObjectMapping() {
        this.tableMapper = mobileConfigHeadingLookup;
    }
    onBtnEditClicked() {
        if (this.tableSelection.length === 0) {
            this.appControllerService.showMessage(this.selectMobMessage, AlertType.Warning);
            return;
        }
        if (this.tableSelection.length > 1) {
            this.appControllerService.showMessage(this.moreThanOneMobSelectedMessage, AlertType.Warning);
            return;
        }
        const selectedMobileConfig = this.tableSelection[0];
        const modalOptions = this.getModalOptions(SharedConstants.MODAL_SIZE.extraLarge);
        const modalRef = this.modalService.open(EditMobileConfigComponent, modalOptions);
        modalRef.componentInstance.modalTitle = this.editModalTitle;
        modalRef.componentInstance.mobId = selectedMobileConfig.id;
        modalRef.componentInstance.existingMobileConfigs = this.existingMobileConfigs;
        modalRef.result.then(refreshUsers => {
            if (refreshUsers) {
                this.getMobileConfigs();
            }
        }).catch((res) => {
        });
    }
    onBtnCreateClicked() {
        const modalOptions = this.getModalOptions(SharedConstants.MODAL_SIZE.extraLarge);
        const modalRef = this.modalService.open(CreateMobileConfigComponent, modalOptions);
        modalRef.componentInstance.modalTitle = this.addModalTitle;
        modalRef.componentInstance.existingMobileConfigs =
            this.existingMobileConfigs;
        modalRef.result
            .then((refreshSurveys) => {
            if (refreshSurveys) {
                this.getMobileConfigs();
            }
        })
            .catch((res) => {
        });
    }
    getModalOptions(modalSize) {
        return {
            size: modalSize,
            centered: true,
            keyboard: false,
            backdrop: "static",
        };
    }
    static ctorParameters = () => [
        { type: MobileConfigSettingsService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: NgbModal }
    ];
};
MobileConfigComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-mobile-config",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], MobileConfigComponent);
export { MobileConfigComponent };
